import styled from "styled-components";

import { colors } from "../../consts";

import WrapperContainer from "../Containers/WrapperContainer";
import { Paragraph2 } from "../Text/Paragraphs";
import { Header, ModalContainer } from "../Modal/styled";
import { IconWrapper, InputComponentWrapper } from "../Input/styled";
import DropdownInput from "../DropdownInput/DropdownInput";

export const HiddenOptionsCircle = styled(Paragraph2)`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;

  color: ${colors.RAISIN_100};

  background-color: ${colors.ISABELLINE_DARKER};
  border-radius: 70px;

  padding: 0 8px;
`;

export const FilterInputContainer = styled(WrapperContainer)`
  gap: 4px;
  padding: 10px 8px;

  border-radius: 12px;

  transition: background-color 250ms ease-out;
  cursor: pointer;

  &:hover {
    background-color: ${colors.ISABELLINE_DARKER};
  }

  span {
    color: ${colors.RAISIN_100};
    ${(props) => props.active && `font-weight: 700;`}
  }

  path {
    fill: ${colors.RAISIN_100};
  }
`;

export const Description = styled(Paragraph2)`
  padding-bottom: 18px;
  font-weight: 400;
  color ${colors.RAISIN_80};
`;

export const FilterModalContainer = styled(ModalContainer)`
  ${Header} {
    margin-bottom: 0;
  }
`;

export const FilterDropdown = styled(DropdownInput)`
  width: auto !important;
  min-width: unset;

  padding: 8px;
  border-radius: 12px;

  transition: background-color 250ms ease-out;

  &:hover {
    background-color: ${colors.ISABELLINE_DARKER};
  }

  &.active {
    background-color: ${colors.ISABELLINE_DARKER};
  }

  ${InputComponentWrapper} {
    background-color: transparent;
    border: none;
    outline: none;

    padding: 0 4px;
    min-height: unset;

    span {
      color: ${colors.RAISIN_100};
      ${(props) => props.active && `font-weight: 700;`}
    }

    &:hover {
      box-shadow: unset;
    }
  }

  ${IconWrapper} {
    position: unset;
    height: unset;

    path {
      fill: ${colors.RAISIN_100};
    }
  }
`;
